import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import {
  NbsIbscbsAdmin,
  NbsIbscbsCombinationModel,
  NbsIbscbsListModel,
  NbsSearchResult,
} from "../../../domain/models/nbs-ibscbs";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteNbsIbscbsAdmin implements NbsIbscbsAdmin {
  constructor(
    private readonly url: string,
    private readonly nbsUrl: string,
    private readonly httpClient: HttpClient
  ) {}

  async searchNbs(query: string): Promise<NbsSearchResult[]> {
    const httpResponse = await this.httpClient.request({
      url: this.nbsUrl,
      method: "get",
      params: { query },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async listByNbsId(nbsId: number): Promise<NbsIbscbsListModel> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/nbs/${nbsId}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async setDefault(id: number): Promise<NbsIbscbsCombinationModel> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}/set-default`,
      method: "put",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
